// extracted by mini-css-extract-plugin
export default {"wrapper":"invoice-created-modal_wrapper__ZRFGo","button":"invoice-created-modal_button__Ahr1D","opacity-transition":"invoice-created-modal_opacity-transition__gSWI5"};